<div>
    <ng-container *ngFor="let attribute of attributes; let i = index" [ngSwitch]="attribute.datatype">
        <div class="attributeRow" [class]="{
                odd: i % 2 != 0,
                even: i % 2 == 0,
                ptgAttribute: showAll
            }" (click)="showAttributeValidation(attribute.id)">
            <div>
                <div *ngIf="attribute.description" matTooltip="{{ attribute.description }}"
                    [matTooltipPosition]="'below'" matTooltipClass="tooltip"
                    style="display: flex; justify-content: center">
                    <img [src]="'/assets/img/icons/info.png'" alt="Beschreibungs-Icon" />
                </div>
            </div>
            <b>{{ attribute.name }}</b>
            <div>
                <div class="optional" *ngIf="showOptional">
                    <validation-icon [value]="attribute.optional"></validation-icon>
                </div>
                <div *ngIf="
                        !showOptional &&
                        !showAll &&
                        !showCheckbox &&
                        attributeNameEditable
                    " class="triangle" [class]="{ turn: attribute.hidden }"></div>
                <div *ngIf="showCheckbox">
                    <mat-checkbox (click)="toggleValidation(attribute)" [(ngModel)]="
                            checkedValidations[attribute.validations[0].id]
                        ">
                    </mat-checkbox>
                </div>
            </div>
        </div>
        <div class="validationRow" [class]="{ hidden: attribute.hidden }"
            *ngFor="let validation of attribute.validations">
            <div *ngIf="attributeNameEditable" class="triplecolumn">
                <p>
                    <mat-form-field appearance="legacy" class="formfield">
                        <mat-label>{{ attribute.name }}</mat-label>
                        <input matInput placeholder="Attributename" [(ngModel)]="this.newAttributeName" />
                        <mat-hint>Merkmalsname</mat-hint>
                    </mat-form-field>
                </p>
                <button matButton="elevated" (click)="this.saveChanges(attribute.id)" class="attrButton" color="primary">
                    Speichern
                </button>
                <button matButton="elevated" (click)="this.abortEdit(attribute.id)" class="attrButton" color="primary">
                    Abbrechen
                </button>
            </div>
        </div>
    </ng-container>
</div>